import React from 'react';
import { CircularProgress } from 'material-ui/Progress';

const Loader = () => {
  const center = {
    margin: '100px 50%'
  };

  return (
    <div style={center}>
      <CircularProgress style={{marginLeft: -25}} size={50} />
    </div>
  );
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/index.js